<template>
    <div>
        <mt-cell :title="model.caption" :required="param.required" :disabledcolor="!!param.disabled" v-if="!param.readonly" :titlewidth="titlewidth" :value-align="textalign">
            <mt-switch v-model="currentValue" :disabled="!!param.disabled" @change="handleChange"></mt-switch>
        </mt-cell>
        <mt-cell :title="model.caption" :readonly="param.readonly" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign">
            <div class="em-select-value mt-color-grey-lv3">
                <template>{{displayValue}}</template>
            </div>
        </mt-cell>
        <!-- <mt-field :label="model.caption" v-if="param.readonly" readonly v-model="displayValue" :titlewidth="titlewidth" :value-align="textalign"></mt-field> -->
    </div>
</template>
<script>
export default {

    name: 'emSwitcher',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: { default: '0' },
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }
    },

    data() {
        return {
            currentValue: this.value * 1 === 1
        };
    },

    watch: {
        value(val) {
            this.currentValue = val * 1 === 1;
        }
    },

    computed: {
        param() {
            return this.model.initParam;
        },
        displayValue() {
            return this.value * 1 === 1 ? '是' : '否';
        }
    },

    methods: {
        handleChange() {
            this.$emit('sync-change', this.currentValue ? '1' : '0', this.model.name);
        }
    }
}
</script>
<style lang="css">
</style>


// WEBPACK FOOTER //
// emSwitcher.vue?6a9d12ff